const imagesCarousel = {
  backgroundColor: ({ theme }) => theme.colors.lightGreen,
}

export default imagesCarousel
